import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IGroupModel } from '../../../models/groups.model';

@Injectable({
    providedIn: 'root',
})
export class GroupContextService {
    groupDetailsSubject = new BehaviorSubject<IGroupModel>({} as IGroupModel);
    groupDetails$ = this.groupDetailsSubject.asObservable();
    memberListSource = new Subject<void>();
    memberList$ = this.memberListSource.asObservable();
    memberJoinRequestListSource = new Subject<void>();
    memberJoinRequestList$ = this.memberJoinRequestListSource.asObservable();
    myGroupsSource = new Subject<void>();
    myGroupsList$ = this.myGroupsSource.asObservable();
    pinnedGroupsSource = new Subject<void>();
    pinnedGroupsList$ = this.pinnedGroupsSource.asObservable();
    groupInvitesSource = new Subject<void>();
    groupInvitesList$ = this.groupInvitesSource.asObservable();
    groupReportsSource = new Subject<void>();
    groupReportsList$ = this.groupReportsSource.asObservable();

    setGroupDetails(value: IGroupModel): void {
        this.groupDetailsSubject.next(value);
    }

    notifyMemberListUpdated(): void {
        this.memberListSource.next();
    }

    notifyMemberJoinRequestListUpdated(): void {
        this.memberJoinRequestListSource.next();
    }

    notifyMyGroupsListUpdated(): void {
        this.myGroupsSource.next();
    }

    notifyPinnedGroupsListUpdated(): void {
        this.pinnedGroupsSource.next();
    }

    notifyGroupInvitesUpdated(): void {
        this.groupInvitesSource.next();
    }

    notifyGroupReportsUpdated(): void {
        this.groupReportsSource.next();
    }
}
